import * as React from 'react';

export function RadioFacet(props) {
  const {label, options, onChange: setFilter, initialFacetValues = [], isFirstFacet = false} = props;

  // Auto-cascade for subsequent facets: if the current selection has count=0,
  // replace it with the first valid option in a single state update.
  React.useEffect(() => {
    if (isFirstFacet) return;

    const selected = options.find(o => o.selected);
    if (selected && selected.count > 0) return;

    const firstValid = options.find(o => o.count > 0);
    if (firstValid) setFilter(firstValid.value);
  }, [options, isFirstFacet]);

  const merged = React.useMemo(() => {
    const existing = new Map(options.map(o => [o.value, o]));
    const missing = initialFacetValues
      .filter(v => !existing.has(v))
      .map(v => ({value: v, count: 0, selected: false}));
    return [...options, ...missing].sort((a, b) => String(a.value).localeCompare(String(b.value)));
  }, [options, initialFacetValues]);

  return (
    <fieldset>
      <legend>{label}</legend>
      {merged.map(option => {
        const disabled = !isFirstFacet && option.count === 0;
        return (
          <label key={option.value} className={disabled ? 'disabled' : ''}>
            <input
              type="radio"
              name={label}
              checked={option.selected}
              data-checked={option.selected}
              disabled={disabled}
              onChange={() => {
                if (option.selected) return;
                setFilter(option.value);
              }}
            />
            <span>{option.value} <span className='counter'>({option.count})</span></span>
          </label>
        );
      })}
    </fieldset>
  );
}
